var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useIntl } from 'react-intl';
import Button from './Button';
import Typography from './Typography';
import theme from '../consts/theme';
var rootStyles = css({
    backgroundColor: theme.colors.white,
    padding: '2rem 0',
    position: 'fixed',
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 51,
});
var innerStyles = css({
    boxSizing: 'border-box',
    margin: '0 auto',
    maxWidth: '42rem',
    padding: '0 2rem',
    width: '100%',
});
var contentStyles = css({
    textAlign: 'center',
});
var buttonWrapperStyles = css((_a = {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        justifyContent: 'center',
        marginTop: '1rem'
    },
    _a[theme.breakpoints.lg] = {
        flexDirection: 'row-reverse',
    },
    _a));
var BodyLink = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  appearance: none;\n  background-color: transparent;\n  border: none;\n  color: ", ";\n  cursor: pointer;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  padding: 0;\n  text-decoration: underline;\n"], ["\n  appearance: none;\n  background-color: transparent;\n  border: none;\n  color: ", ";\n  cursor: pointer;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  padding: 0;\n  text-decoration: underline;\n"])), theme.colors.helsinkiBlue);
var Banner = function (_a) {
    var visible = _a.visible, onAcceptAllClick = _a.onAcceptAllClick, onManageCookiesClick = _a.onManageCookiesClick;
    var t = useIntl().formatMessage;
    if (!visible)
        return null;
    return (_jsx("div", { "data-cy": "consent-manager-banner", css: rootStyles, children: _jsxs("div", { css: innerStyles, children: [_jsxs("div", { css: contentStyles, children: [_jsx(Typography, { css: css({ marginBottom: '1rem' }), variant: "h2", El: "h2", children: t({ id: 'cookie_title' }) }), _jsx(Typography, { children: t({
                                id: 'banner_content',
                            }, {
                                accept_link: (_jsx(BodyLink, { id: "accept-all", type: "button", "data-cy": "acceptcookies", onClick: onAcceptAllClick, children: t({ id: 'accept_cookies' }) })),
                                managecookies_link: (_jsx(BodyLink, { id: "open-consent", type: "button", "data-cy": "managecookies", onClick: onManageCookiesClick, children: t({ id: 'manage_cookies' }) })),
                            }) })] }), _jsxs("div", { css: buttonWrapperStyles, children: [_jsx(Button, { variant: "primary", id: "accept", "data-cy": "button-accept-all-cookies", onClick: onAcceptAllClick, children: t({ id: 'banner_accept_all' }) }), _jsx(Button, { variant: "basic", "data-cy": "manage_cookies", onClick: onManageCookiesClick, css: css({ color: theme.colors.helsinkiBlue }), children: t({ id: 'manage_cookies' }) })] })] }) }));
};
export default Banner;
var templateObject_1;
